export default __webpack_public_path__ + "static/media/recycle-bin-16.b4d7cdf8.svg";